import { FilterOption } from '../hooks/useDetailsFilter';

// ============================================================================
// API, Storage & Caching Configurations
// ============================================================================
export const LEGACY_IMPACT_BASEPATH =
  'datapoints/legacy-api/service-api/impact';
export const SDG_S3_DOWNLOADS_BASE_URL =
  'https://impact-full-rankings.s3.eu-west-1.amazonaws.com';

export const CACHE_ONE_HOUR = {
  staleTime: Infinity,
  cacheTime: 1000 * 60 * 60,
};

// ============================================================================
// Navigation & Routing URL Paths
// ============================================================================
export const IMPACT_OVERVIEW_URL = '/datapoints/sdg/overview';
export const IMPACT_DETAILS_BASE_URL = '/datapoints/sdg/details';

// ============================================================================
// Layout & Visual Sizing Dimensions
// ============================================================================
export const SDG_TOPBAR_HEIGHT = 20;
export const MIN_BOXPLOT_HEIGHT = '141px'; // Required to prevent Plotly's internal container collapsing
export const MIN_CARD_HEIGHT = '217px';
export const MIN_CARD_HEIGHT_MOBILE = '312px';

// ============================================================================
// Core Domain Constants & Limits
// ============================================================================
export const SDG_MAX_INDEX = 17;
export const MAX_INSTITUTION_SELECTION = 35;
export const SDG_DOWNLOAD_DEFAULT_FILE_NAME = 'SDG_download';
export const IMPACT_STARTING_YEAR = 2019;
export const SDG_MEMBERSHIP_BANNER_URL =
  'https://www.timeshighereducation.com/our-solutions/data-and-insights/sustainability-impact-network-membership?utm_source=datapoints&utm_medium=banner&utm_campaign=overview_banner';

export const SDG_CONTINENTS = [
  'Europe',
  'Africa',
  'Asia',
  'Oceania',
  'North America',
  'South America',
] as const;

// ============================================================================
// File Downloads & Report Generation
// ============================================================================
export const SDG_SCORE_VALUE_TITLES: string[] = [
  'Your Rank',
  'Institutions ranked',
  'Your Score',
  'Top - Worldwide',
  '75% - Worldwide',
  'Median - Worldwide',
  '25% - Worldwide',
  'Bottom - Worldwide',
];
export const SDG_SUMMARY_HEADERS: string[] = [
  '',
  'Score',
  'Rank',
  'Institutions ranked',
  'SDG Participated',
  'Total SDGs',
];
export const SDG_METRICS_COLUMNS: string[] = [
  'SDG',
  'Metric name',
  'Score',
  'Rank',
  'Institutions ranked',
];
export const SDG_BREAKDOWN_HEADERS: string[] = ['SDG', 'Metric Name', 'Score'];

// ============================================================================
// UI Filter & Select Control Options
// ============================================================================
export const REFERENCE_GROUP_FILTER_LABEL = 'Select reference group';

export const DETAILS_FILTER_REFERENCE_GROUP_DEFAULT: FilterOption = {
  label: 'Worldwide',
  value: 'Worldwide',
};

export const DETAILS_FILTER_PERFORMANCE_OPTIONS: FilterOption[] = [
  { label: 'All institutions', value: '' },
  { label: 'Top 20 institutions', value: 'top-20' },
];

export const DETAILS_FILTER_SORT_BY_OPTIONS: FilterOption[] = [
  { label: 'Name A-Z', value: 'name-asc' },
  { label: 'Name Z-A', value: 'name-desc' },
  { label: 'SDG Performance', value: 'rank-asc' },
];

// ============================================================================
// User-Facing Strings & Error Notifications
// ============================================================================
export const NO_INSTITUTIONS_FOUND_MESSAGE =
  'No institutions found matching your criteria.';
export const NO_INSTITUTIONS_SELECTED_MESSAGE =
  'You have not selected any institutions.';
export const NO_SDGS_ERROR_MSG =
  'Error loading SDGs, please refresh and try again';
export const SDG_OVERVIEW_TITLE = 'Sustainability Impact Ratings';
